import { useCallback } from "react";

import {
  useAddUrlParam,
  useRemoveUrlParams,
  useUserID,
} from "Utilities/urlParamHooks";

const useOpenHouseholdProfile = ({ householdID, memberID } = {}) => {
  const userID = useUserID();
  const addUrlParam = useAddUrlParam();
  const removeUrlParams = useRemoveUrlParams();

  return useCallback(() => {
    if (householdID) {
      addUrlParam("householdID", householdID);
      removeUrlParams("profileTab");
    } else {
      removeUrlParams("householdID");
    }
    if (memberID && userID !== memberID) {
      window.fnReactBus.loadUserProfile(memberID, false, {
        showHouseholdInfo: Boolean(householdID),
      });
    } else window.fnReactBus.navigateToProfileTab("householdInfo");
  }, [householdID, memberID, userID, addUrlParam, removeUrlParams]);
};

export default useOpenHouseholdProfile;
